export default {
  GET_NEWS: (state) => state.news,
  GET_ACTIVE_NEWS: (state) => state.active_news,
  GET_SINGLE_NEWS: (state) => state.single_news,
};
